type ListProps = {
  listEntries: string[];
  listType?: string;
};

export const List = ({ listEntries, listType = 'default' }: ListProps) => {
  const listTypes = {
    numbered: {
      list: 'list-decimal pl-[1rem]',
      element: 'mb-2',
    },
    alphabetical: {
      list: 'list-alphabetical pl-[1rem]',
      element: 'mb-2',
    },
    disc: {
      list: 'list-disc pl-[1rem]',
      element: 'mb-1',
    },
    default: {
      list: '',
      element: '',
    },
    square: {
      list: 'list-square pl-[1rem]',
      element: 'mb-2',
    },
    benefits: {
      list: '',
      element: 'flex items-start gap-2 mb-2',
    },
  };

  const key = listType as keyof typeof listTypes;

  if (listType === 'numbered' || listType === 'alphabetical') {
    return (
      <ol className={listTypes[key].list}>
        {listEntries.map((entry, index) => (
          <li className={listTypes[key].element} key={index}>
            {entry}
          </li>
        ))}
      </ol>
    );
  }

  return (
    <ul className={listTypes[key].list}>
      {listEntries.map((entry, index) => (
        <li className={listTypes[key].element} key={index}>
          {listType === 'benefits' ? (
            <svg
              aria-hidden='true'
              className='text-primary mt-[5px] h-3.5 w-3.5 shrink-0'
              fill='currentColor'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z' />
            </svg>
          ) : null}
          <span>{entry}</span>
        </li>
      ))}
    </ul>
  );
};
